export default __webpack_public_path__ + "static/media/testi1.ef2317ee.png";